// START Open Requre.JS wrapper
define([
	'jquery',
	'wcs.context',
	'pubsub'
], function($,ctx,pubsub) {
// END Open Require.JS wrapper


/****
* Populates the cart link in the utility nav
***/
	var DEBUG = false;
	var PLUGIN_IDENTIFIER = "utilityNavCart";
	var utilityNavCart;

	(function(){
		utilityNavCart = {
			defaults: {
				el: ".topnav-cart, .unav-shoppingbag-js", // CMS Topnav Selector, Legacy Topnav Selector
				dataAttr: "cart-options",
				replaceSelector: '.topnav-cart-qty', // String to replace with quantity
				classHasProducts: 'has-products' // Class to add to the cart when it is not empty
			},

			/**
			 * Initialize plugin
			 **/
			init : function() {
				if ( DEBUG ) console.log('initilizing ' + PLUGIN_IDENTIFIER);

				var self = this; // Make plugin namespace available throughout
				self.deferred = $.Deferred();

				self.$element = $(self.defaults.el);
				self.$cartLink = self.$element.find('a');
				self.metadata = self.$element.data(self.defaults.dataAttr);
				self.config = $.extend( {}, self.defaults, self.metadata );

				// Make adjustments for Legacy Topnav
				// TODO - Remove this when Vans switches to CMS Topnav
				if(self.$element.hasClass('unav-shoppingbag-js')) {
					self.config.replaceSelector = ".nav-shoppingbag-qty-js";
				}

				self.events();

				self.deferred.resolve();

				return self.update();
			},

			/**
			 * Setup events that update the cart link
			 **/
			events: function() {
				var self = this;
				// Update count when user adds to cart
				$.pubsub('subscribe', 'SHOPCART_UPDATED', function(event,data) { self.update(); } );

				// Update count when user removes from cart

				// Update count when page is loaded

				// Update count when user logs in

				// Update count when user logs out

				// Update count on order confirmation since cart should now be empty
			},

			/**
			 * Update the cart link
			 **/
			update: function() {
				var self = this;
				return self.updateDisplay( self.getCount() );
			},

			/**
			 * Get the current number of items in the cart per
			 * user cookies. Guarantees a numeric response.
			 **/
			getCount: function() {
				var count = Number(ctx.getShoppingCart().quantity);
				return (isNaN(count)) ? 0 : count;
			},

			/**
			 * Update the displayed count of items in the cart
			 * @param int Number to display in cart
			 **/
			updateDisplay: function(count) {
				var self = this,
					$countElement = $(self.config.replaceSelector);

				// Update display text of inner span
				$countElement.text(count);

				// Unhide count
				$countElement.removeClass('hide');

				// Set appropriate class on utility nav item
				if(count > 0) {
					self.$element.addClass(self.config.classHasProducts);
					self.toggleAriaDescription(true);
				} else {
					self.$element.removeClass(self.config.classHasProducts);
					self.toggleAriaDescription(false);
				}

				// Set a flag for better performance in subsequent updates (Future use)
				self.config.replaced = true;

				// Allow for chaining
				return self;
			},

			/**
			 * Toggles keyboard aria-described labeling in cart link
			 * @param booleaan enables/disables cart instructions
			 **/
			toggleAriaDescription: function(enable) {
				// Multiple cart links exist on a page
				// If we don't have any products in the cart
				// the minicart won't open so we don't need to
				// enable the keyboard instructions
				this.$cartLink.removeAttr('aria-describedby');
				if(enable) {
					// add the instrustions pointer to the cart link if we have products
					this.$cartLink.each(function(index, link) {
						var instructionsId = $(link).data('ariaDescribedby');
						if(instructionsId && $('#'+instructionsId).length) {
							$(link).attr('aria-describedby', instructionsId);
						}
					});
				}
			}
		};

		return utilityNavCart.init();

	})();

	return utilityNavCart;

});
